import { useEffect, useState } from "react";
import { getOrdersStatistics } from "../../utils/dataFetch";
import ResponsiveTable from "../svg-graphs/ResponsiveTable";

export default function OrdersStatistics({ endDate }) {
    const [error, setError] = useState("");
    const [showModalTable, setShowModalTable] = useState(false);

    const [overallAmount, setOverallAmount] = useState(0);
    const [overallIncome, setOverallIncome] = useState(0);
    const [averageCheck, setAverageCheck] = useState(0);
    const [checkCount, setCheckCount] = useState(0);
    const [activeCheckCount, setActiveCheckCount] = useState(0);
    const [activeAmount, setActiveAmount] = useState(0);
    const [popularMenu, setPopularMenu] = useState([]);

    useEffect(() => {
        const fetchOrdersReport = async () => {
            try {
                const tempStart = new Date(endDate);
                tempStart.setHours(0, 0, 0, 0);
                const tempEnd = new Date(endDate);
                tempEnd.setHours(23, 59, 59, 999);
                const result = await getOrdersStatistics(tempStart, tempEnd);
                setOverallAmount(result.overallAmount);
                setOverallIncome(result.overallIncome);
                setAverageCheck(result.averageCheck);
                setCheckCount(result.checkCount);
                setActiveCheckCount(result.activeCheckCount);
                setActiveAmount(result.activeAmount);
                setPopularMenu(result.popularMenu);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };
        fetchOrdersReport();
    }, [endDate]);

    function sortAndGroup(data) {
        // Групуємо елементи за parent_name
        const groupedData = data.reduce((acc, item) => {
            const parentName = item.parent_name;
            if (!acc[parentName]) {
                acc[parentName] = [];
            }
            acc[parentName].push({ ...item, styles: "text-left align-middle fw-normal" });
            return acc;
        }, {});

        const sortedResult = [];
        const sortedParentNames = Object.keys(groupedData).sort();

        sortedParentNames.forEach((parentName) => {
            // Сортуємо елементи всередині папки за значенням values[0]
            const sortedGroupItems = groupedData[parentName].sort((a, b) => b.values[0] - a.values[0]);

            // Обчислюємо суми для values[0] та values[1]
            const totalValues = sortedGroupItems.reduce(
                (sum, item) => {
                    sum[0] += item.values[0];
                    sum[1] += item.values[1];
                    return sum;
                },
                [0, 0]
            );
            const parentId = sortedGroupItems[0].parent_id;

            // Додаємо Папку з обчисленими сумами
            sortedResult.push({
                id: "pid" + parentId,
                label: parentName,
                parent_name: parentName,
                values: totalValues,
                valueStyles: "text-center align-middle fw-bold",
            });
            sortedResult.push(...sortedGroupItems);
        });

        return sortedResult;
    }

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                {error && <div className="alert alert-danger m-auto rounded-5">{error}</div>}
                {!error && (
                    <>
                        <div className="row d-flex flex-column mt-1">
                            <h5 className="text-center fw-bold mb-2">Виконані замовлення</h5>
                            <div className="col col-auto m-0 ms-1 me-1 p-0 text-center d-flex justify-content-around">
                                <div className="m-0 p-0 text-center">
                                    <div>Виручка</div>
                                    <div className="fw-light">{overallAmount}</div>
                                </div>
                                <div className="border-end border-1 border-black" style={{ width: "1px" }}></div>
                                <div className="m-0 p-0 text-center">
                                    <div>Дохід</div>
                                    <div className="fw-light">{overallIncome}</div>
                                </div>
                                <div className="border-end border-1 border-black" style={{ width: "1px" }}></div>
                                <div className=" m-0 p-0 text-center">
                                    <div>Сер. чек</div>
                                    <div className="fw-light">{averageCheck}</div>
                                </div>
                                <div className="border-end border-1 border-black" style={{ width: "1px" }}></div>
                                <div className="m-0 p-0 text-center">
                                    <div>Кількість</div>
                                    <div className="fw-light">{checkCount}</div>
                                </div>
                            </div>
                            {activeCheckCount > 0 && (
                                <>
                                    <h5 className="text-center fw-bold mb-2 mt-2">Замовлення в процесі</h5>
                                    <div className="col col-auto m-0 ms-1 me-1 p-0 text-center d-flex justify-content-around">
                                        <div className="m-0 p-0 text-center">
                                            <div>Очікувана виручка</div>
                                            <div className="fw-light">{activeAmount}</div>
                                        </div>
                                        <div className="border-end border-1 border-black" style={{ width: "1px" }}></div>
                                        <div className="m-0 mt-1 p-0 text-center">
                                            <div>Кількість</div>
                                            <div className="fw-light">{activeCheckCount}</div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                )}
                <div className="d-flex justify-content-center">
                    <button className="mt-3 btn btn-sm main--button ms-1" onClick={() => setShowModalTable(true)}>
                        Продані товари за день
                    </button>
                </div>

                {showModalTable && (
                    <>
                        <div className="modal--backdrop fade show"></div>
                        <div className="modal show" style={{ display: "block" }} tabIndex="-1">
                            <div className="modal-dialog">
                                <div className="modal-content rounded-5">
                                    <div className="modal-header">
                                        <h5 className="modal-title ms-0">Всі товари</h5>
                                        <button type="button" className="btn-close me-0" onClick={() => setShowModalTable(false)}></button>
                                    </div>
                                    <div className="modal-body p-0">
                                        <ResponsiveTable data={sortAndGroup(popularMenu)} headLabels={["Кількість", "Сума"]} rowLabel={"Назва"} />
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-sm main--button" onClick={() => setShowModalTable(false)}>
                                            Закрити
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
